export default __webpack_public_path__ + "static/media/NH Publications on Unstable Haemoglobin diseases.262d12fc.pdf";